import React from 'react';
import { ReactComponent as OpenInNew } from 'assets/svg/openInNew.svg';
import eCBubbleLogo from './eCBubbleLogo.png';
import welcomeGraphic from './welcomeGraphic.png';

export const eCLogo = ({ className }) => <img src={eCBubbleLogo} alt="eConsult logo" className={className} />;
export const WelcomeGraphic = ({ className }) => <img src={welcomeGraphic} alt="Welcome graphic" className={className} />;
export const OpenInNewIcon = ({ className, automationName }) => <OpenInNew className={className} data-automation={automationName} />;
